<script>
    import { fontPreference } from "../../stores.js";

    export let showLabel = true;

    async function selectFont(fontId) {
        await fontPreference.setFont(fontId);
        // Remove focus to close dropdown
        if (document.activeElement) {
            document.activeElement.blur();
        }
    }
</script>

<div class="font-selector-container">
    {#if showLabel}
        <span class="label">Police</span>
    {/if}

    <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm btn-outline">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-4 h-4"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                />
            </svg>
            <span class="hidden sm:inline ml-1">
                {fontPreference.availableFonts.find(f => f.id === $fontPreference)?.label || 'Police'}
            </span>
        </div>

        <ul
            tabindex="0"
            class="dropdown-content menu z-[1] p-2 shadow-2xl bg-base-100 rounded-box w-64 mt-2"
        >
            {#each fontPreference.availableFonts as font}
                <li>
                    <button
                        type="button"
                        class="font-item"
                        class:active={$fontPreference === font.id}
                        on:click={() => selectFont(font.id)}
                    >
                        <div class="font-preview" style={font.fontFamily ? `font-family: ${font.fontFamily}` : ''}>
                            <span class="font-label">{font.label}</span>
                            <span class="font-sample">AaBbCc 123</span>
                        </div>
                        {#if $fontPreference === font.id}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 text-success flex-shrink-0"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        {/if}
                    </button>
                </li>
            {/each}
        </ul>
    </div>
</div>

<style>
    .font-selector-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 0.5rem;
    }

    .label {
        font-weight: 500;
        font-size: 0.9rem;
    }

    .font-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        padding: 0.5rem;
        cursor: pointer;
        border-radius: 0.5rem;
        transition: background-color 0.2s;
        border: none;
        background: transparent;
    }

    .font-item:hover {
        background-color: hsl(var(--b2));
    }

    .font-item.active {
        background-color: hsl(var(--b2));
    }

    .font-preview {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }

    .font-label {
        font-weight: 600;
        font-size: 0.875rem;
    }

    .font-sample {
        font-size: 0.75rem;
        opacity: 0.7;
    }
</style>
